export const OPEN_BUTTON_DATA_SCHEMA = 'StylableButton';
export const OPEN_BUTTON_TYPE = 'wixui.HamburgerMenuOpenButton';
export const OPEN_BUTTON_PROP_TYPES = 'StylableButtonProperties';
